export default {
  container: {
    marginTop: 10
  }
};
